module.exports = __webpack_public_path__ + "media/cha.mp3";